<template>
  <!-- prettier-ignore -->
  <div class="Accordion">
    <partner-widget-expander
      v-for="(products, category, index) in productsTree"
      :key="category"
      :title="$t(`content.categories.${category}.title`)"
      :initialize-opened="index === 0"
      @opened="onOpened(category)"
    >
      <product-detail
        v-for="product in products"
        :key="product.productId"
        :product="product"
        :package-id="product.packageId"
        :labels="tm(`content.products.${product.productId}`)"
        class="product"
      />
    </partner-widget-expander>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import PartnerWidgetExpander from '@/modules/PartnerWidget/components/PartnerWidgetExpander'
import ProductDetail from '@/modules/PartnerWidget/components/product/ProductDetail'

// Hooks
const { tm } = useI18n()

// Props
defineProps({
  productsTree: {
    type: Object,
    default: () => ({}),
  },
})

// Init
const emit = defineEmits(['opened'])

// Methods
function onOpened(categoryId) {
  emit('opened', categoryId)
}
</script>

<style scoped>
.Accordion {
  .product:not(:last-of-type) {
    border-bottom: 1px solid var(--c-secondary-neutral-3);
  }
}
</style>
<style name="short" scoped>
@media screen and (max-height: 596px) {
  .Accordion {
    max-height: 100%;
  }
}
</style>
